import { render, staticRenderFns } from "./M-index.vue?vue&type=template&id=7f9d6f5b&scoped=true&"
import script from "./M-index.vue?vue&type=script&lang=js&"
export * from "./M-index.vue?vue&type=script&lang=js&"
import style0 from "./M-index.vue?vue&type=style&index=0&id=7f9d6f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9d6f5b",
  null
  
)

export default component.exports